//用户信息

<template>
<div>
	<header-vue></header-vue>
	
  <div class="container-l5 clearfix">
	  	<div class="black-top-left">
			<div class="black-box1 clearfix">
				<div class="black-box1-1">
					<h3 class="black-h31">物联网关</h3>
					<legend-one :normalName="'在线'" :abnormalName="'离线'"></legend-one>
					<div class="chartbox4 clearfix">
						<div v-if="gateway_status.cabinet">							
							<chart-one :online="gateway_status.cabinet.online || 0" :offline="gateway_status.cabinet.offline || 0"
							:legendData="['在线','离线']" :chartName="'机柜'" :chartID="'charts1'">
							</chart-one>
						</div>
						<div v-if="gateway_status.power">							
							<chart-one :online="gateway_status.power.online || 0" :offline="gateway_status.power.offline || 0"
							:legendData="['在线','离线']" :chartName="'动力'" :chartID="'charts2'">
							</chart-one>
						</div>
						<div v-if="gateway_status.environmental">							
							<chart-one :online="gateway_status.environmental.online || 0" :offline="gateway_status.environmental.offline || 0"
							:legendData="['在线','离线']" :chartName="'环境'" :chartID="'charts3'">
							</chart-one>
						</div>					
						
					</div>
					<p class="detail2 clearfix" @click="showModal1()">详情</p>
					
				</div>
				<div class="black-box1-1">
					<h3 class="black-h32">物联机柜</h3>
					<legend-one :normalName="'正常'" :abnormalName="'异常'"></legend-one>				
					<div class="chartbox4 clearfix">

						<div v-if="gateway_data.temperature">							
							<chart-one :online="gateway_data.temperature.normal || 0" :offline="gateway_data.temperature.abnormal || 0"
							:legendData="['正常','异常']" :chartName="'温度'" :chartID="'charts4'">
							</chart-one>
						</div>	
						<div v-if="gateway_data.humidity">							
							<chart-one :online="gateway_data.humidity.normal || 0" :offline="gateway_data.humidity.abnormal || 0"
							:legendData="['正常','异常']" :chartName="'湿度'" :chartID="'charts5'">
							</chart-one>
						</div>
						<div v-if="gateway_data.PDU">							
							<chart-one :online="gateway_data.PDU.normal || 0" :offline="gateway_data.PDU.abnormal || 0"
							:legendData="['正常','异常']" :chartName="'PDU'" :chartID="'charts6'">
							</chart-one>
						</div>

											
					</div>
					<p class="detail2 clearfix" @click="modalFlag2=true">详情</p>
					
				</div>
			</div>
			<div class="black-box1 clearfix">
				<div class="black-box1-1">
					<h3 class="black-h33">环境</h3>
					<legend-one :normalName="'正常'" :abnormalName="'异常'"></legend-one>	
					
					<div class="chartbox4 clearfix">
						<div v-if="gateway_env.temperature">							
							<chart-one :online="gateway_env.temperature.normal || 0" :offline="gateway_env.temperature.abnormal || 0"
							:legendData="['正常','异常']" :chartName="'温度'" :chartID="'charts7'">
							</chart-one>
						</div>

						<div v-if="gateway_env.smoke">							
							<chart-one :online="gateway_env.smoke.normal || 0" :offline="gateway_env.smoke.abnormal || 0"
							:legendData="['正常','异常']" :chartName="'烟感'" :chartID="'charts8'">
							</chart-one>
						</div>
						<div v-if="gateway_env.water">							
							<chart-one :online="gateway_env.water.normal || 0" :offline="gateway_env.water.abnormal || 0"
							:legendData="['正常','异常']" :chartName="'水浸'" :chartID="'charts9'">
							</chart-one>
						</div>
						
					</div>
					<p class="detail2 clearfix" @click="modalFlag3=true">详情</p>
					
				</div>
				<div class="black-box1-1">
					<h3 class="black-h34">动力设施</h3>
					<legend-one :normalName="'正常'" :abnormalName="'异常'"></legend-one>	
					
					<div class="chartbox4 clearfix">
						<div v-if="gateway_power.ups">							
							<chart-one :online="gateway_power.ups.normal || 0" :offline="gateway_power.ups.abnormal || 0"
							:legendData="['正常','异常']" :chartName="'UPS'" :chartID="'charts10'">
							</chart-one>
						</div>
						<div v-if="gateway_power.air">							
							<chart-one :online="gateway_power.air.normal || 0" :offline="gateway_power.air.abnormal || 0"
							:legendData="['正常','异常']" :chartName="'空调'" :chartID="'charts11'">
							</chart-one>
						</div>
						<div v-if="gateway_power.distribution">							
							<chart-one :online="gateway_power.distribution.normal || 0" :offline="gateway_power.distribution.abnormal || 0"
							:legendData="['正常','异常']" :chartName="'配电'" :chartID="'charts12'">
							</chart-one>
						</div>
						
					</div>
					<p class="detail2 clearfix" @click="showModal4()">详情</p>
					
				</div>
			</div>
		</div>
		<div class="black-top-left2 position-relative">
			<div class="rightChooseCom">				
				<choose-company @event1="changeCom($event)"></choose-company>
			</div>
			<model-vue ref="modelchild" :selectComId="selectComId"></model-vue>
		</div>
		<div class="black-top-left3">

			<div class="black-box2">
				<div class="box-box2-s1">
					<el-scrollbar style="height:100%;width:100%;">
						<h3>负载</h3>
									
					
						<div class="progress-box" v-for="(item,index) in cabinet_load" :key="index"> 
							<span>{{item.device_name}}</span>
							<el-progress :text-inside="true" :percentage="parseFloat(item.lod_values)"></el-progress>
						</div>
					</el-scrollbar>					
				
				</div>
				
				<chart-three v-if="threeMonthsEnergyConstitute.length" :chartData="threeMonthsEnergyConstitute" :chartTitle="'能耗 kwh'"
				:chartID="'chart13'">
				</chart-three>
			</div>
			<!-- 告警 -->
			<div class="table-box" style="height: 292px;">
				<el-scrollbar style="height:100%;width:100%;">
					<el-table
					stripe
					border
					:data="tableData"
					style="width: 100%">
						<el-table-column
							prop="name"
							width="80"
							label="告警类别">
						</el-table-column>
						<el-table-column
							prop="msg"
							label="详细信息">
						</el-table-column>
						<el-table-column
							prop="time"
							width="100"
							:formatter="dateFormat"
							label="时间">
						</el-table-column>
					</el-table>
				</el-scrollbar>
				<a class="black-more" href="/#/alarmStatistical">更多>></a>
				
			</div>				
		</div>	  	
		
  		<div class="clearfloat charbox3">
			<chart-two v-if="lastMonthCabinetEnergyTop.name" :chartData="lastMonthCabinetEnergyTop" :chartTitle="'能耗 kwh'"
				:chartID="'chart7'">
			</chart-two>
			<chart-two v-if="temperatureTop.name" :chartData="temperatureTop" :chartTitle="'温度 ℃'"
				:chartID="'chart8'">
			</chart-two>				 
  			
  		</div>
		
  	</div>
	  
	<!--物联网关弹框-->
	<el-dialog title="物联网关" :visible.sync="modalFlag1" width="800px" >
		<div style="margin-bottom:30px;">
			<gateway-swiper v-if="modalData1.cabinets && modalData1.cabinets.length" 
			:swiperTitle="'机柜'" :swiperData="modalData1.cabinets || []" :imgUrlNormal="gateway_status_img_normal" :imgUrlAbnormal="gateway_status_img_abnormal">
			</gateway-swiper>
			<gateway-swiper v-if="modalData1.powers && modalData1.powers.length" 
			:swiperTitle="'动力'" :swiperData="modalData1.powers || []" :imgUrlNormal="gateway_status_img_normal" :imgUrlAbnormal="gateway_status_img_abnormal">
			</gateway-swiper>
			<gateway-swiper v-if="modalData1.environmentals && modalData1.environmentals.length" 
			:swiperTitle="'环境'" :swiperData="modalData1.environmentals || []" :imgUrlNormal="gateway_status_img_normal" :imgUrlAbnormal="gateway_status_img_abnormal">
			</gateway-swiper>
		</div>		
	</el-dialog>  

	<!--物联机柜弹框-->
	<el-dialog title="物联机柜" :visible.sync="modalFlag2" width="1100px" >
		<div style="margin-bottom:30px;">
			<el-scrollbar style="height:300px;width:100%;">
				<table-dialog>
				</table-dialog>
			</el-scrollbar>
		</div>		
	</el-dialog>  
	<!--环境弹框-->
	<el-dialog title="环境" :visible.sync="modalFlag3" width="800px" >
		<modal-env></modal-env>
	
	</el-dialog> 

	<!--动力设施弹框-->
	<el-dialog title="动力设施" :visible.sync="modalFlag4" width="800px" >
		<div style="margin-bottom:30px;">
			<gateway-swiper v-if="modalData4.ups && modalData4.ups.length" 
			:swiperTitle="'UPS'" :swiperData="modalData4.ups || []" :imgUrlNormal="gateway_power_img_normal1" :imgUrlAbnormal="gateway_power_img_abnormal1">
			</gateway-swiper>
			<gateway-swiper v-if="modalData4.airs && modalData4.airs.length" 
			:swiperTitle="'空调'" :swiperData="modalData4.airs || []" :imgUrlNormal="gateway_power_img_normal2" :imgUrlAbnormal="gateway_power_img_abnormal2">
			</gateway-swiper>
			<gateway-swiper v-if="modalData4.distributions && modalData4.distributions.length" 
			:swiperTitle="'配电'" :swiperData="modalData4.distributions || []" :imgUrlNormal="gateway_power_img_normal3" :imgUrlAbnormal="gateway_power_img_abnormal3">
			</gateway-swiper>
		
		</div>		
	</el-dialog> 
  </div>

</template>
<script>
	import echarts from "echarts/lib/echarts"
	import 'echarts/map/js/china.js';
	// 正常异常饼图
	import chartOne from './comss/chartOne';
	// 排名柱状图
	import chartTwo from './comss/chartTwo';
	// 图例
	import legendOne from './comss/legendOne';
	// 双层饼图
	import chartThree from './comss/chartThree';
	// 弹框表格
	import tableDialog from './comss/tableDialog';
	// 弹框网关组件swiper
	import gatewaySwiper from './comss/gatewaySwiper';
	// 环境弹框整体组件
	import modalEnv from './comss/modalEnv';
	// 选择公司组件
	import chooseCompany from './comss/chooseCompany.vue'
	
	export default {
		mounted() {
			this.$nextTick(()=>{
				if(this.getCookie('administrators')==1 || this.getCookie('administrators')==2){					
					this.getDetail();					
				}
				this.timer = setInterval(() => {
					this.getDetail();			
				}, 30000);
							
			})			

			this.$once('hook:beforeDestroy', () => {
				clearInterval(this.timer);
			})
    	},
		components:{
			chartOne,chartTwo,legendOne,chartThree,tableDialog,gatewaySwiper,modalEnv,chooseCompany
		},
		watch: {
			// 监控是否有弹框，有弹框就不调用定时器
			'modalFlag1': 'ifGetData',
			'modalFlag2': 'ifGetData',
			'modalFlag3': 'ifGetData',
		},
		data() {
		  	return {
				timer: null,
		  		terminalDevice:[],
		  		collectDevice:[],
		  		terminalDeviceStatus:[],
		  		alarmDeviceType:[],
		  		alarmDeviceType2:{},
		  		userStastics:{},
		  		company_id:-1,
		  		alarmList:[],
		  		monthAlarmNum:0,
				todayAlarmNum:0,
				tableData: [],
				// 物联网关
				gateway_status: {},
				modalData1: {},
				modalFlag1: false,
				gateway_status_img_normal: this.$store.state.domain3 + ('plate/网关绿.png'),
				gateway_status_img_abnormal: this.$store.state.domain3 + ('plate/网关红.png'),				
				// 物联机柜
				gateway_data: {},
				modalFlag2: false,				
				//环境
				gateway_env: {},
				modalFlag3: false,
				// 动力设施
				gateway_power: {},
				modalData4: {},
				modalFlag4: false,
				gateway_power_img_normal1: this.$store.state.domain3 + ('plate/UPS绿.png'),
				gateway_power_img_abnormal1: this.$store.state.domain3 + ('plate/UPS红.png'),	
				gateway_power_img_normal2: this.$store.state.domain3 + ('plate/空调绿.png'),
				gateway_power_img_abnormal2: this.$store.state.domain3 + ('plate/空调红.png'),
				gateway_power_img_normal3: this.$store.state.domain3 + ('plate/配电绿.png'),
				gateway_power_img_abnormal3: this.$store.state.domain3 + ('plate/配电红.png'),
				// 温度排名
				temperatureTop: {},
				// 能耗排名
				lastMonthCabinetEnergyTop: {},
				// 机柜负载排名
				cabinet_load: [],
				// 能耗饼图
				threeMonthsEnergyConstitute: [],
				// 选择公司
				areaFlag: false,
				selectComId: 999

		  	}
		},
		methods:{
			getDetail(){
				this.tableData = {};
				this.gateway_data = {};
				this.gateway_status = {};
				this.gateway_env = {};
				this.gateway_power = {};
				this.temperatureTop = {};
				this.lastMonthCabinetEnergyTop = {};
				this.cabinet_load = [];
				this.threeMonthsEnergyConstitute = [];
				let valiCodeParams={
					uid:this.getCookie('uid'),
					company_id: this.selectComId || 999,
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
				};
				
				this.sign2(valiCodeParams);
				this.$ajax.post(this.$store.state.domain2+"/admin/Workbench/List",this.$qs.stringify(valiCodeParams),{
					emulateJSON: true
				}).then(res=>{
					if(res.data.code=="200"){
						this.tableData = res.data.data.alarm || {};
						this.gateway_data = res.data.data.gateway_data || {};
						this.gateway_status = res.data.data.gateway_status || {};
						this.gateway_env = res.data.data.gateway_env || {};
						this.gateway_power = res.data.data.gateway_power || {};
						this.temperatureTop = res.data.data.temperatureTop || {};
						this.lastMonthCabinetEnergyTop = res.data.data.lastMonthCabinetEnergyTop || {};
						this.cabinet_load = res.data.data.cabinet_load || [];
						this.threeMonthsEnergyConstitute = res.data.data.threeMonthsEnergyConstitute || [];
						
						// this.$message.success(res.data.msg);
					}else if(res.data.code==10008){
							this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
					}else{
						// this.$message.error(res.data.msg);
					}
				});
			},
			// 选择公司及区域后调用方法
			toChooseCompanyMethod(){
				this.getDetail();		
				this.$refs.modelchild.getLoad();	

			},
			// 选择公司，子传父
			changeCom(data){
				this.selectComId = data.selectComId || "";
			
			},
			// 判断是否频繁请求数据，有弹框不不请求定时器，没有弹框调用定时器
			ifGetData(){
				if(this.modalFlag2==true){
					clearInterval(this.timer);
				}else{
					clearInterval(this.timer);
					this.timer = setInterval(() => {
						this.getDetail();			
					}, 30000);
				}
			},
			
			// 物联网关弹框
			showModal1(){
				this.modalFlag1 = true;
				let valiCodeParams={
					uid:this.getCookie('uid'),
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
				};
				
				this.sign2(valiCodeParams);
				this.$ajax.post(this.$store.state.domain2+"/admin/Workbench/gateway_status_list",this.$qs.stringify(valiCodeParams),{
					emulateJSON: true
				}).then(res=>{
					if(res.data.code=="200"){
						this.modalData1 = res.data.data || {};
						// this.$message.success(res.data.msg);
					}else if(res.data.code==10008){
						
						this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
					}else{
						this.$message.error(res.data.msg);
					}
				});
			},
			// 动力设施弹框
			showModal4(){
				this.modalFlag4 = true;
				let valiCodeParams={
					uid:this.getCookie('uid'),
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
				};
				
				this.sign2(valiCodeParams);
				this.$ajax.post(this.$store.state.domain2+"/admin/Workbench/power_facilities_list",this.$qs.stringify(valiCodeParams),{
					emulateJSON: true
				}).then(res=>{
					if(res.data.code=="200"){
						this.modalData4 = res.data.data || {};
						// this.$message.success(res.data.msg);
					}else if(res.data.code==10008){
						
						this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
					}else{
						this.$message.error(res.data.msg);
					}
				});
			},
			
			

		
			
		
		}
	}

</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/plate2.vue